import React, { Component } from 'react'
import { Pane, IconButton, MenuIcon } from 'evergreen-ui'

import Logo from './Logo';
import Account from './Account';
import './OrchestraHeader.css';

export default class OrchestraHeader extends Component {
    render() {
        return (
            <Pane background="tint2"
                elevation={1} 
                padding={8} 
                display="flex" 
                alignItems="center"
                justifyContent="space-between"
                >
                <Pane display="flex" alignItems="center">
                    <IconButton 
                        icon={MenuIcon}
                        appearance="minimal"
                        onClick={this.props.onToggleSidebar}
                        className="mobile-menu-toggle"
                        marginRight={8}
                    />
                    <Logo/>
                </Pane>

                <Pane display="flex" alignItems="center">
                    <a
                        href="/v2/pos"
                        title="Deschide casa de marcat (POS)"
                        className="orchestra-pos-pill"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            padding: '6px 12px',
                            marginRight: 12,
                            fontSize: 13,
                            fontWeight: 500,
                            color: 'white',
                            background: '#52BD94',
                            borderRadius: 4,
                            textDecoration: 'none',
                        }}
                    >
                        POS
                    </a>
                    <a
                        href="/v2"
                        title="Incearca noua versiune a aplicatiei"
                        className="orchestra-version-pill"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            padding: '6px 12px',
                            marginRight: 12,
                            fontSize: 13,
                            fontWeight: 500,
                            color: '#3366FF',
                            background: '#EBF0FF',
                            borderRadius: 4,
                            textDecoration: 'none',
                        }}
                    >
                        <span className="orchestra-version-pill-text">Versiunea noua</span>
                        <span
                            className="orchestra-version-pill-badge"
                            style={{
                                marginLeft: 6,
                                padding: '1px 6px',
                                fontSize: 10,
                                fontWeight: 700,
                                color: 'white',
                                background: '#3366FF',
                                borderRadius: 999,
                            }}
                        >
                            NOU
                        </span>
                    </a>
                    <Account/>
                </Pane>
                
            </Pane>
        )
    }
}